import { render } from "./kisProducts.vue?vue&type=template&id=596f8e4c&scoped=true"
import script from "./kisProducts.vue?vue&type=script&lang=js"
export * from "./kisProducts.vue?vue&type=script&lang=js"

import "./kisProducts.vue?vue&type=style&index=0&id=596f8e4c&scoped=true&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596f8e4c"]])

export default __exports__